import { render, staticRenderFns } from "./CreateLoteGeneralInformation.vue?vue&type=template&id=cb88cf16"
import script from "./CreateLoteGeneralInformation.vue?vue&type=script&lang=js"
export * from "./CreateLoteGeneralInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports